import { objectSpread2 as _objectSpread2 } from './_virtual/_rollupPluginBabelHelpers.mjs';
import React, { useContext } from 'react';
import { ThemeContext } from 'styled-components';
import { SizeWrapper, TouchWrapper } from './styles/styledComponents.mjs';
import { jsx, jsxs } from 'react/jsx-runtime';

var Svg24Myshopping1 = /*#__PURE__*/React.memo(function (props) {
  useContext(ThemeContext);
  props.iconColor;
  var component = /*#__PURE__*/jsx("svg", _objectSpread2(_objectSpread2({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), {}, {
    children: /*#__PURE__*/jsxs("g", {
      fill: props.iconColor ? props.iconColor : "#010505",
      fillRule: "evenodd",
      children: [/*#__PURE__*/jsx("path", {
        d: "M15.013 7.187c.328 0 .6.236.656.546l.011.12v1.614a3.34 3.34 0 0 1-3.35 3.2 3.34 3.34 0 0 1-3.234-3.006L9.08 9.44V7.853a.666.666 0 0 1 1.323-.12l.01.12v1.56a1.996 1.996 0 0 0 1.934 1.92 2 2 0 0 0 1.984-1.71l.016-.183V7.853c0-.368.298-.666.666-.666"
      }), /*#__PURE__*/jsx("path", {
        d: "M17.973 2.84H6.533a2.4 2.4 0 0 0-2.4 2.4l-1.33 13.535C2.8 20.18 3.876 21.253 5.2 21.253h14.107a2.4 2.4 0 0 0 2.4-2.4L20.37 5.162c.003-1.247-1.071-2.322-2.397-2.322m-11.44 1.6h11.44a.8.8 0 0 1 .8.8l1.337 13.691c-.003.364-.362.722-.803.722H5.2a.8.8 0 0 1-.8-.8L5.73 5.318c.003-.52.362-.878.803-.878"
      })]
    })
  }));
  if (props.size) {
    component = /*#__PURE__*/React.createElement(SizeWrapper, {
      size: props.size
    }, component);
  }
  if (props.touch) {
    component = /*#__PURE__*/React.createElement(TouchWrapper, {
      size: props.size,
      touch: props.touch
    }, component);
  }
  return component;
});
var Svg24Myshopping1$1 = Svg24Myshopping1;

export { Svg24Myshopping1$1 as default };
